import { addClass } from '@opten/dom/add-class';
import { Component } from '@opten/compiler/metadata/component';
import { debounce } from '@opten/reactive/debounce';

declare const Swiper: any;

@Component({ className: 'js-text-slider' })
export class TextSliderComponent {
	constructor(private element: HTMLElement) {
		const paginations = Array.from(element.getElementsByClassName('js-text-slider-pagination')) as HTMLElement[];
		const autoplay = parseInt(this.element.getAttribute('data-autoplay'), 0) || 0;
		const swiper = new Swiper(element, {
			autoplay: (autoplay > 0 ? {
				delay: autoplay,
			  } : false),
			autoHeight: true,
			speed: 1000,
			pagination: {
				el: '.swiper-pagination',
				clickable: true,
				renderBullet: (index, className) => {
					const pagination = paginations[index];
					addClass(pagination, className);
					return pagination.outerHTML;
				},
			},
			keyboard: {
				enabled: true,
				onlyInViewport: true,
			},
		});

		window.addEventListener(
			'resize',
			debounce(() => {
				swiper.updateAutoHeight(0);
			}, 400)
		);
	}
}
